import { jsx, jsxs } from "react/jsx-runtime";
import { cn } from "../utils.js";
const EmptyState = ({ title, description, icon, image, primaryAction, secondaryContent, highlightedText, className, small, style })=>/*#__PURE__*/ jsxs(EmptyStateContainer, {
        className: className,
        style: style,
        children: [
            icon && /*#__PURE__*/ jsx(EmptyStateIcon, {
                small: small,
                children: icon
            }),
            image && /*#__PURE__*/ jsx("img", {
                width: 190,
                height: 152,
                src: image.src,
                alt: image.alt || 'empty illustration',
                className: "tw-mb-1.6"
            }),
            /*#__PURE__*/ jsxs(EmptyStateTitle, {
                small: small,
                children: [
                    title,
                    highlightedText && /*#__PURE__*/ jsx("span", {
                        className: "tw-text-primary-light-500",
                        children: highlightedText
                    })
                ]
            }),
            /*#__PURE__*/ jsx(EmptyStateDescription, {
                small: small,
                children: description
            }),
            primaryAction && /*#__PURE__*/ jsx("div", {
                className: "tw-mb-1.6",
                children: primaryAction
            }),
            secondaryContent
        ]
    });
const EmptyStateContainer = ({ children, className, style })=>/*#__PURE__*/ jsx("section", {
        className: cn('tw-w-full tw-flex tw-flex-col tw-items-center tw-justify-center tw-p-3.2 sm:tw-p-[10rem]', className),
        style: style,
        children: children
    });
const EmptyStateIcon = ({ children, className, style, small })=>/*#__PURE__*/ jsx("div", {
        className: cn(' tw-bg-neutral-light-300 tw-rounded-full tw-flex tw-justify-center tw-items-center', !small && 'tw-size-6 tw-mt-4 tw-mb-1', small && 'tw-size-4 tw-m-0', className),
        style: style,
        children: children
    });
const EmptyStateTitle = ({ children, small, className })=>/*#__PURE__*/ jsx("span", {
        className: cn('tw-text-center tw-block tw-mb-0.8', small && 'tw-font-subtitle5 tw-mt-0.8', !small && 'tw-font-subtitle4 tw-mt-2', className),
        children: children
    });
const EmptyStateDescription = ({ children, small, className })=>/*#__PURE__*/ jsx("span", {
        className: cn('tw-font-body5 tw-text-center tw-block tw-text-neutral-light-700', small && 'tw-mb-0.8', !small && 'tw-mb-1.6', className),
        children: children
    });
export { EmptyState, EmptyStateContainer, EmptyStateDescription, EmptyStateIcon, EmptyStateTitle };
